import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useNewHomepageEffects from "./useNewHomepageEffects";
import MobileNavDrawer from "./MobileNavDrawer";
import "./newHomepage.css";

const NewHomepage = () => {
  const rootRef = useRef(null);
  const navigate = useNavigate();
  const [html, setHtml] = useState("");
  const [loadError, setLoadError] = useState("");

  useNewHomepageEffects(rootRef, html);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/new-homepage.html?v=150`)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load homepage (${res.status})`);
        return res.text();
      })
      .then(setHtml)
      .catch((err) => setLoadError(err.message));
  }, []);

  useEffect(() => {
    const root = rootRef.current;
    if (!root || !html) return;

    const email = localStorage.getItem("email");
    const loginLabel = email ? "Log Out" : "Login / Sign Up";
    const loginEls = document.querySelectorAll(
      ".new-homepage-root [data-login-link], .nav-mobile-drawer [data-login-link]"
    );
    if (!loginEls.length) return;

    const onLoginClick = (e) => {
      e.preventDefault();
      if (email) {
        localStorage.removeItem("email");
        window.location.reload();
        return;
      }
      navigate("/login");
    };

    loginEls.forEach((loginEl) => {
      loginEl.textContent = loginLabel;
      loginEl.addEventListener("click", onLoginClick);
    });

    const blogLinks = [];
    root.querySelectorAll('a[href="/blog/Vidyam-llm"]').forEach((link) => {
      const onBlogClick = (e) => {
        e.preventDefault();
        navigate("/blog/Vidyam-llm");
      };
      link.addEventListener("click", onBlogClick);
      blogLinks.push({ link, onBlogClick });
    });

    return () => {
      loginEls.forEach((loginEl) => {
        loginEl.removeEventListener("click", onLoginClick);
      });
      blogLinks.forEach(({ link, onBlogClick }) =>
        link.removeEventListener("click", onBlogClick)
      );
    };
  }, [navigate, html]);

  if (loadError) {
    return (
      <div className="new-homepage-root" style={{ padding: "2rem", color: "#fff" }}>
        Failed to load homepage: {loadError}
      </div>
    );
  }

  if (!html) {
    return (
      <div
        className="new-homepage-root"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "rgba(255,255,255,0.6)",
        }}
      >
        Loading…
      </div>
    );
  }

  return (
    <>
      <div
        className="new-homepage-root"
        ref={rootRef}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <MobileNavDrawer />
      <div id="galleryLightbox">
        <div className="lb-inner">
          <button className="lb-close" id="lb-close-btn" type="button">
            ✕
          </button>
          <div className="lb-content" id="lb-content-bg">
            <img className="lb-photo" id="lb-photo" src="" alt="" />
            <div className="lb-caption">
              <div className="lb-label" id="lb-label">
                Gallery
              </div>
              <div className="lb-sub" id="lb-sub">
                Vidyam AI — Real classrooms, real impact.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="videoLightbox">
        <div className="lb-inner video-lb-inner">
          <button className="lb-close" id="video-lb-close-btn" type="button">
            ✕
          </button>
          <div className="video-lb-content">
            <iframe
              id="video-lb-iframe"
              title="Vidyam AI video"
              src=""
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      <div id="problemCardLightbox" className="problem-card-lightbox" aria-hidden="true">
        <div className="problem-card-lightbox-backdrop" />
        <div className="problem-card-lightbox-stage">
          <div className="problem-card-lightbox-shell">
            <button
              type="button"
              className="problem-card-lightbox-close"
              id="problem-card-lb-close"
              aria-label="Close card"
            >
              ✕
            </button>
            <div className="problem-card-lightbox-body" id="problem-card-lb-body" />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewHomepage;
